import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Status } from '@df/core/status';

@Component({
    selector: 'section1',
    templateUrl: './section1.html',
    styleUrls: ['./section1.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Section1Component {
    @Input()
    sectionIcon?: string;

    @Input()
    sectionTitle?: string;

    @Input()
    actionCopy?: string;

    @Input()
    actionStatus?: Status;

    @Output()
    action = new EventEmitter<void>();
}
